export default "__VITE_ASSET__Ig0dfixs__"